import { startOfYear, endOfYear, format } from 'date-fns';
import permitStatisticsService from '@/api/permit-statistics-service';

export const getDefaultPermitStatisticsFilterParams = () => ({
  date_from: format(startOfYear(new Date()), 'yyyy-MM-dd'),
  date_to: format(endOfYear(new Date()), 'yyyy-MM-dd'),
  group_by: 'type',
});

export const getDefaultPermitStatusStatisticsFilterParams = () => ({
  date_from: format(startOfYear(new Date()), 'yyyy-MM-dd'),
  date_to: format(endOfYear(new Date()), 'yyyy-MM-dd'),
});

const state = {
  permitStatistics: null,
  permitStatusStatistics: null,
  permitStatisticsChartData: null,
  permitStatisticsFilterParams: getDefaultPermitStatisticsFilterParams(),
  permitStatusStatisticsFilterParams: getDefaultPermitStatusStatisticsFilterParams(),
  permitStatisticsDisplayMode: 'text', // 'text' or 'chart'
};

const getters = {};

const mutations = {
  SET_PERMIT_STATISTICS(state, statistics) {
    state.permitStatistics = statistics;
  },

  SET_PERMIT_STATUS_STATISTICS(state, statistics) {
    state.permitStatusStatistics = statistics;
  },

  SET_PERMIT_STATISTICS_CHART_DATA(state, statistics) {
    state.permitStatisticsChartData = statistics;
  },

  SET_PERMIT_STATISTICS_FILTER_PARAMS(state, params) {
    state.permitStatisticsFilterParams = params;
  },

  SET_PERMIT_STATUS_STATISTICS_FILTER_PARAMS(state, params) {
    state.permitStatusStatisticsFilterParams = params;
  },

  SET_PERMIT_STATISTICS_DISPLAY_MODE(state, mode) {
    state.permitStatisticsDisplayMode = mode;
  },
};

const actions = {
  fetchPermitStatistics({ commit }, params = {}) {
    commit('SET_PERMIT_STATISTICS_FILTER_PARAMS', params);
    return permitStatisticsService.getPermitStatistics(params).then((res) => {
      commit('SET_PERMIT_STATISTICS', res.data);
    });
  },

  fetchPermitStatusStatistics({ commit }, params = {}) {
    commit('SET_PERMIT_STATUS_STATISTICS_FILTER_PARAMS', params);
    return permitStatisticsService.getPermitStatusStatistics(params).then((res) => {
      commit('SET_PERMIT_STATUS_STATISTICS', res.data);
    });
  },

  fetchPermitStatisticsChartData({ commit }, params = {}) {
    commit('SET_PERMIT_STATISTICS_FILTER_PARAMS', params);
    return permitStatisticsService.getPermitStatisticsChartData(params).then((res) => {
      commit('SET_PERMIT_STATISTICS_CHART_DATA', res.data);
    });
  },

  setPermitStatisticsDisplayMode({ commit }, mode) {
    commit('SET_PERMIT_STATISTICS_DISPLAY_MODE', mode);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
